class ResizeObserverService {
    private observedHandlers = new Map<Element, () => unknown>();
    private resizeObserver = new ResizeObserver((entries) => {
        entries.forEach(({ target }) => {
            const handler = this.observedHandlers.get(target);
            if (handler) {
                handler();
            }
        });
    });

    observe(element: Element, handler: () => unknown) {
        this.observedHandlers.set(element, handler);
        this.resizeObserver.observe(element);
    }

    unobserve(element: Element) {
        this.resizeObserver.unobserve(element);
        this.observedHandlers.delete(element);
    }
}

export default new ResizeObserverService();
